import { containers } from '@ecosystem/newron-design-system';
import AverageSellingPriceChart from '@data-visualization/average-selling-price-chart/AverageSellingPriceChart';
import { AveragePriceChartResp } from '@data-visualization/average-selling-price-chart/Types';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { AVERAGE_SELLING_PRICE } from '@pages/Utilities';
import { FactRevenue, PageType } from '@utils/pageConfig/Types';
import React, { useCallback } from 'react';
import { ExportFormat } from '@ecosystem/newron-client-lib';
import { CreateInsightDataFn } from '@ecosystem/newron-client-collections';
import { RetailerOverviewLineChartInsight } from '@components/collections/retailer-overview-line-chart/Model';
import RetailerOverviewHeaderIcon from '../header-icon/RetailerOverviewHeaderIcon';
import { CollectionInsightType } from '@components/collections/Model';
import { useExportImages } from '@hooks/export/UseExportChartImage';
import { generateUniqueChartKeys } from '@data-visualization/utilities/GenerateUniqueChartKeys';
import { GeneralViewState } from '@models/SavedViews';

export interface Props {
  data: AveragePriceChartResp;
  selectedPeriodicity: Periodicity;
  isLoading: boolean;
  factRevenue: FactRevenue;
  volume: string;
  isRetailerOverview: boolean;
  onChartDownload?: (exportFormats: ExportFormat[]) => Promise<void>;
  createInsightDataFn?: CreateInsightDataFn<RetailerOverviewLineChartInsight>;
  isUsingCollection?: boolean;
  overviewState: GeneralViewState;
}

const AveragePriceCard: React.FC<Props> = ({
  data,
  selectedPeriodicity,
  isLoading,
  factRevenue,
  volume,
  isRetailerOverview,
  onChartDownload = async () => {},
  createInsightDataFn,
  isUsingCollection,
  overviewState,
}) => {
  const { Card } = containers;
  const { exportImages } = useExportImages(PageType.RETAILER_OVERVIEW);
  const createViewState = useCallback(() => overviewState, [overviewState]);

  const shouldDisableButton = !exportImages[generateUniqueChartKeys(data)] || isLoading || !data; //NOSONAR typescript:S6606

  return (
    <Card testId={AVERAGE_SELLING_PRICE}>
      <Card.Title title={AVERAGE_SELLING_PRICE}>
        <Card.Title.Actions>
          {isRetailerOverview && createInsightDataFn && (
            <RetailerOverviewHeaderIcon
              title="Average Selling Price"
              isDisabled={shouldDisableButton}
              isPerformanceTrend={false}
              onChartDownload={onChartDownload}
              volume={volume}
              createInsightDataFn={createInsightDataFn}
              collectionInsightType={CollectionInsightType.RetailerOverviewLineChart}
              createViewStateFn={createViewState}
            />
          )}
        </Card.Title.Actions>
      </Card.Title>
      <Card.Content>
        <AverageSellingPriceChart
          isLoading={isLoading}
          data={data}
          selectedPeriodicity={selectedPeriodicity}
          factRevenue={factRevenue}
          isUsingCollection={isUsingCollection}
        />
      </Card.Content>
    </Card>
  );
};

export default AveragePriceCard;
